export default {
    employeeList: [],
  }
  